export default {
    employeeList: [],
  }
  